export default function AnalyticsTable({ processedData, groupBy }) {
  const groupLabel = groupBy.charAt(0).toUpperCase() + groupBy.slice(1);

  return (
    <div className="rounded-xl bg-white p-6 shadow-md">
      <h3 className="mb-4 text-lg font-semibold text-gray-900">Detailed Breakdown by {groupLabel}</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              {[
                groupLabel,
                "Total Subscribers",
                "India Subscribers",
                "International Subscribers",
                "Revenue (INR)",
                "Revenue (USD)",
                "Free Trial Users",
                "Cancelled Users",
              ].map((heading) => (
                <th
                  key={heading}
                  className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {processedData.map((item) => (
              <tr key={item.period} className="hover:bg-gray-50">
                <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">{item.period}</td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                  {item.totalSubscribers.toLocaleString()}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                  {item.nationalSubscribers.toLocaleString()}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                  {item.internationalSubscribers.toLocaleString()}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                  ₹{item.totalRevenueINR.toLocaleString()}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                  ${item.totalRevenueUSD.toLocaleString()}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                  {item.freeTrialUsers.toLocaleString()}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                  {item.cancelledRecurring.toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
